import api from "../security/api";

const immediates = (client, instance, request) => {
    return api
        .post(`wsbancovalores/saveImmediates?client=${client}&instance=${instance}`, request);

};

const valo = {
    immediates
}

export default valo;